import React, {useEffect, useState} from 'react';
import './App.css';
import CookieConsent, {Cookies, getCookieConsentValue,} from "react-cookie-consent";
import firebase from "firebase/app";
import {ToastsContainer, ToastsContainerPosition, ToastsStore} from 'react-toasts';
import {BrowserRouter, Route, Routes, Navigate} from "react-router-dom";
import Header from "./component/structural/header";
import Login from "./component/structural/login";
import DashboardPage from "./component/structural/dashboardPage";
import ProfilePage from "./component/structural/profilePage";
import TransactionHistoryPage from "./component/structural/transactionHistoryPage";
import FriendsPage from "./component/structural/friendsPage";
import AddFriendPage from "./component/structural/addFriendPage";
import ResetPasswordPage from "./component/structural/resetPasswordPage";
import FriendRequestActionPage from "./component/structural/friendRequestActionPage";
import RegisterPage from "./component/structural/registerPage";
import LogoutPage from "./component/structural/logoutPage";
import 'react-datepicker/dist/react-datepicker.css'
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import themeService from "./services/themeService";
import i18nService from "./i18n/i18nService";

export enum ToastErrorLevel {
    INFO, ERROR
}

function App() {

    const [loggedIn, setLoggedIn] = useState(false);

    const handleAcceptCookie = () => {
        firebase.analytics();
    };

    const handleDeclineCookie = () => {
        // remove google analytics cookies
        Cookies.remove("_ga");
        Cookies.remove("_gat");
        Cookies.remove("_gid")
    };

    useEffect(() => {
        const isConsent = getCookieConsentValue();
        if (isConsent === "true") {
            handleAcceptCookie();
        }
        // Initialize theme and locale
        themeService.syncFromUser();
    }, []);

    const addToastMessage = (body: string,
                             level: ToastErrorLevel): any => {
        switch (level) {
            case ToastErrorLevel.ERROR: {
                ToastsStore.error(body)
                break;
            }
            case ToastErrorLevel.INFO: {
                ToastsStore.info(body)
                break;
            }
        }
    }

    // @ts-ignore
    return (
        <div className="dark-theme App-wrapper">
            <div className="App">
                <ToastsContainer position={ToastsContainerPosition.TOP_RIGHT} store={ToastsStore}/>
                <BrowserRouter>
                    <Routes>
                        <Route path="/login" element={<div>
                            <Header key={"Header-" + loggedIn}/><Login toastGenerator={addToastMessage} onLogin={() => {
                            setLoggedIn(true);
                        }
                        }/></div>}/>
                        <Route path="/reset-password" element={<div>
                            <Header key={"Header-" + loggedIn}/>
                            <ResetPasswordPage toastGenerator={addToastMessage}/>
                        </div>}/>
                        <Route path="/register" element={<div>
                            <Header key={"Header-" + loggedIn}/>
                            <RegisterPage toastGenerator={addToastMessage}/>
                        </div>}/>
                        <Route path="/profile/add-friend/:username" element={<div>
                            <Header key={"Header-" + loggedIn}/>
                            <AddFriendPage toastGenerator={addToastMessage} onLogout={() => {
                                setLoggedIn(false);
                            }}/>
                        </div>}/>
                        <Route path="/friend-requests/accept" element={<div>
                            <Header key={"Header-" + loggedIn}/>
                            <FriendRequestActionPage toastGenerator={addToastMessage} action="accept"/>
                        </div>}/>
                        <Route path="/friend-requests/reject" element={<div>
                            <Header key={"Header-" + loggedIn}/>
                            <FriendRequestActionPage toastGenerator={addToastMessage} action="reject"/>
                        </div>}/>
                        <Route path="/dashboard" element={<div>
                            <Header key={"Header-" + loggedIn}/>
                            <DashboardPage toastGenerator={addToastMessage} onLogout={() => {
                                setLoggedIn(false);
                            }}/>
                        </div>}/>
                        <Route path="/profile" element={<div>
                            <Header key={"Header-" + loggedIn}/>
                            <ProfilePage toastGenerator={addToastMessage} onLogout={() => {
                                setLoggedIn(false);
                            }}/>
                        </div>}/>
                        <Route path="/history" element={<div>
                            <Header key={"Header-" + loggedIn}/>
                            <TransactionHistoryPage toastGenerator={addToastMessage} onLogout={() => {
                                setLoggedIn(false);
                            }}/>
                        </div>}/>
                        <Route path="/friends" element={<div>
                            <Header key={"Header-" + loggedIn}/>
                            <FriendsPage toastGenerator={addToastMessage} onLogout={() => {
                                setLoggedIn(false);
                            }}/>
                        </div>}/>
                        <Route path="/logout" element={<div>
                            <Header key={"Header-" + loggedIn}/>
                            <LogoutPage onLogout={() => {
                                setLoggedIn(false);
                            }}/>
                        </div>}/>
                        <Route path="/" element={<Navigate to="/dashboard" replace />}/>
                        <Route path="*" element={<Navigate to="/dashboard" replace />}/>
                    </Routes>
                </BrowserRouter>
            </div>
            <CookieConsent enableDeclineButton onAccept={handleAcceptCookie} onDecline={handleDeclineCookie}>
                This website uses cookies to enhance the user experience.
            </CookieConsent>
            <script src="/__/firebase/8.4.1/firebase-app.js"/>
            <script src="/__/firebase/init.js"/>
        </div>

    );
}

export default App;
